/*
  Dolvak · Yorum fotoğrafı tıklaması

  Judge.me'de yorum kartındaki bir fotoğrafa tıklayınca açılan görüntüleyici
  SADECE o yoruma ait fotoğrafları geziyor; müşteri sağa-sola kaydırıp diğer
  yorumları göremiyordu.

  Widget'ın üstündeki medya galerisinden açılan görüntüleyici ise TÜM
  fotoğrafları karusel olarak geziyor ve her fotoğrafın altında o yorumun
  yazarını, tarihini ve metnini gösteriyor — istenen davranış bu.

  Bu yüzden kart içindeki fotoğraf tıklamasını yakalayıp, aynı fotoğrafın
  üstteki galerideki karşılığına yönlendiriyoruz. Eşleşme bulunamazsa
  Judge.me'nin kendi davranışı aynen çalışmaya devam eder.
*/
(function () {
  var KART_FOTO = '.jm-media-thumbnail-list__thumbnail';
  var GALERI_DUGME = 'button.jm-media-grid__item';

  function anahtar(src) {
    if (!src) return '';
    try {
      return new URL(src, location.href).pathname;
    } catch (e) {
      return String(src).split('?')[0];
    }
  }

  function gorselAdresi(el) {
    var im = el.tagName === 'IMG' ? el : el.querySelector('img');
    if (im) return im.currentSrc || im.src || im.getAttribute('data-src') || '';
    // arka plan görseli ihtimali
    var bg = getComputedStyle(el).backgroundImage || '';
    var m = bg.match(/url\(["']?([^"')]+)/);
    return m ? m[1] : '';
  }

  function galerideBul(yol) {
    if (!yol) return null;
    var dugmeler = document.querySelectorAll(GALERI_DUGME);
    for (var i = 0; i < dugmeler.length; i++) {
      var im = dugmeler[i].querySelector('img');
      if (!im) continue;
      var s = im.currentSrc || im.src || im.getAttribute('data-src') || '';
      if (anahtar(s) === yol) return dugmeler[i];
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var kart = e.target.closest ? e.target.closest(KART_FOTO) : null;
      if (!kart) return;
      // üstteki galerinin kendi öğelerine dokunma
      if (e.target.closest(GALERI_DUGME)) return;

      var hedef = galerideBul(anahtar(gorselAdresi(kart)));
      if (!hedef) return; // eşleşme yok → Judge.me kendi akışını sürdürsün

      e.preventDefault();
      e.stopPropagation();
      hedef.click();
    },
    true
  );

  /*
    Görüntüleyicide ürün kartı.
    Rakipte (Loox) fotoğrafın yanında "satın alınan ürün + Ürünü Gör" kartı
    çıkıyor; Judge.me bunu basmıyor ve sağ sütun boş kalıyor. Katman açılınca
    kartı biz ekliyoruz. Ürün bilgisi theme.liquid'den window.dvAnaUrun ile
    geliyor; yoksa hiçbir şey eklenmez.
  */
  function urunKartiEkle(icerik) {
    if (!window.dvAnaUrun || !window.dvAnaUrun.url) return;
    if (icerik.querySelector('.dv-urun-karti')) return;
    if (icerik.querySelector('a[href*="/products/"]')) return; // Judge.me kendi bastıysa karışma

    var u = window.dvAnaUrun;
    var a = document.createElement('a');
    a.className = 'dv-urun-karti';
    a.href = u.url;
    a.innerHTML =
      (u.gorsel ? '<img src="' + u.gorsel + '" alt="" width="44" height="44">' : '') +
      '<span class="dv-urun-karti__ad"></span>' +
      '<span class="dv-urun-karti__dugme">Ürünü Gör</span>';
    a.querySelector('.dv-urun-karti__ad').textContent = u.ad || 'Ürünü incele';
    icerik.appendChild(a);
  }

  var gozlemci = new MutationObserver(function () {
    document.querySelectorAll('.jdgm-modal .jm-content').forEach(urunKartiEkle);
  });
  gozlemci.observe(document.documentElement, { childList: true, subtree: true });
})();
